import Vue from 'vue'
import VueRouter, { RouteConfig, RouterOptions } from 'vue-router'
import qs from 'qs'
import pickBy from 'lodash/pickBy'

import AccountRegistrationRoutes from '@/modules/account-registration.routes'
import UserRegistrationRoutes from '@/modules/user-registration.routes'
import DashboardRoutes from '@/modules/dashboard.routes'
import MailboxesRoutes from '@/modules/mailboxes.routes'
import ProjectsRoutes from '@/modules/projects.routes'
import CalendarRoutes from '@/modules/calendar.routes'
import PeopleRoutes from '@/modules/people.routes'
import WorkflowsRoutes from '@/modules/workflows.routes'
import DevelopersRoutes from '@/modules/developers.routes'
import TicketPortalRoutes from '@/modules/ticket-portal.routes'

import { beforeEach } from '@/services/router/router.guards'
import * as routerNames from './router.names'
import store from '@/services/store/store'

import ErrorScreen from '@/screens/errors/error-screen.vue'
import DDErrorHandler from '@/plugins/dd-error-handler/dd-error-handler'
import GoogleDriveAuthSuccess from '@/screens/google-drive-auth-success/google-drive-auth-success.vue'

// Install Vue-Router into Vue
Vue.use(VueRouter)

// Build list of routes
export const routes: RouteConfig[] = [
  ...AccountRegistrationRoutes,
  ...UserRegistrationRoutes,
  ...DashboardRoutes,
  ...MailboxesRoutes,
  ...ProjectsRoutes,
  ...CalendarRoutes,
  ...PeopleRoutes,
  ...WorkflowsRoutes,
  ...DevelopersRoutes,
  ...TicketPortalRoutes,
  {
    path: '/',
    beforeEnter: (to, from, next) => {
      window.location.href = process.env.VUE_APP_SERVER_SIDE_APP_URL
    },
  },
  {
    path: '*',
    name: routerNames.NOT_FOUND,
    component: ErrorScreen,
    beforeEnter: (to, from, next) => {
      store.set('app/error', 404)
    },
  },

  /**
   * Loading state on Google Drive
   */
  {
    path: '/:accountId/googledriveauth',
    name: routerNames.GOOGLE_DRIVE_AUTH,
    component: GoogleDriveAuthSuccess,
    meta: {
      visibleTo: [1, 2, 3],
      private: true,
    },
  },
]

export const routerOptions: RouterOptions = {
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  parseQuery(query: string) {
    const stringToParse = query.startsWith('?') ? query.substring(1) : query
    return qs.parse(stringToParse, { comma: true })
  },
  stringifyQuery(query: any) {
    const filteredQuery = pickBy(query, v => v !== null && String(v).length > 0)
    const queryString = qs.stringify(filteredQuery, {
      arrayFormat: 'comma',
      encode: false,
    })
    return queryString ? `?${queryString}` : ''
  },
}

// @ts-ignore
const route = new VueRouter(routerOptions)

// Management of all routes
route.beforeEach((to: any, from: any, next: any) =>
  beforeEach(to, from, next, new DDErrorHandler(route, store), store),
)

export default route
